var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_350_506)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 35.75H22C18.35 35.75 16.25 33.65 16.25 30V20C16.25 16.35 18.35 14.25 22 14.25H30C33.65 14.25 35.75 16.35 35.75 20V30C35.75 33.65 33.65 35.75 30 35.75ZM22 15.75C19.14 15.75 17.75 17.14 17.75 20V30C17.75 32.86 19.14 34.25 22 34.25H30C32.86 34.25 34.25 32.86 34.25 30V20C34.25 17.14 32.86 15.75 30 15.75H22Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 22.25H30.5C28.98 22.25 27.75 21.02 27.75 19.5V17.5C27.75 17.09 28.09 16.75 28.5 16.75C28.91 16.75 29.25 17.09 29.25 17.5V19.5C29.25 20.19 29.81 20.75 30.5 20.75H32.5C32.91 20.75 33.25 21.09 33.25 21.5C33.25 21.91 32.91 22.25 32.5 22.25Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 26.75H22C21.59 26.75 21.25 26.41 21.25 26C21.25 25.59 21.59 25.25 22 25.25H26C26.41 25.25 26.75 25.59 26.75 26C26.75 26.41 26.41 26.75 26 26.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 30.75H22C21.59 30.75 21.25 30.41 21.25 30C21.25 29.59 21.59 29.25 22 29.25H30C30.41 29.25 30.75 29.59 30.75 30C30.75 30.41 30.41 30.75 30 30.75Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_350_506",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_350_506"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_350_506",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.6a36b3110554a45f0cbb56b96aff0b42.svg";
export { ForwardRef as ReactComponent };